import type { TRouteObject } from "@ch/helpers/utils/types";

import ErrorPage from "@ch/pages/ErrorPage";
import MindfulnessPageLazy from "@ch/pages/MindfulnessPage";
import NotFoundPage from "@ch/pages/NotFoundPage";

const MindfulnessRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <MindfulnessPageLazy />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default MindfulnessRoutes;
